"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAmenityInList = void 0;
const React = __importStar(require("react"));
const TaskPage_1 = require("../../base/TaskPage");
const autosave_1 = require("../../../../hooks/autosave");
const data_1 = require("../../../../hooks/data");
const __1 = require("../../../../");
const viewstate_1 = require("../../../../entities/viewstate");
const categories_1 = __importDefault(require("./categories"));
const AmenitySection_1 = require("../../../components/amenities/AmenitySection");
const capitalize_1 = require("../../../../util/capitalize");
const constants_1 = require("../../../../tasks/constants");
const validation_1 = require("../../../../hooks/validation");
const DEFAULT_SUBTYPE_VALUE = 'default';
const newAmenity = (propertyId) => {
    return {
        property: propertyId,
        charge: 0,
        charge_type: '',
        is_present: true,
    };
};
const updateAmenityInList = (selected, propertyId, amenity) => {
    const next = [...selected];
    let existing = next.find((a) => a.amenity_type === amenity.name);
    if (existing)
        next.splice(next.indexOf(existing), 1);
    if (amenity.selected) {
        existing = existing || newAmenity(propertyId);
        next.push(Object.assign(Object.assign({}, existing), { amenity_type: amenity.name, amenity_subtype: amenity.subSelectionValue || DEFAULT_SUBTYPE_VALUE }));
    }
    return next;
};
exports.updateAmenityInList = updateAmenityInList;
const updateManyAmenitiesInList = (selected, propertyId, amenities) => {
    return amenities.reduce((next, amenity) => {
        return (0, exports.updateAmenityInList)(next, propertyId, amenity);
    }, [...selected]);
};
exports.default = (props) => {
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions } = React.useContext(__1.AppContext);
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    (0, validation_1.usePropertyValidation)('amenities', property);
    const { itemTypes, loading } = (0, data_1.useItemTypes)(entityActions);
    const available = itemTypes.amenity_types;
    const selected = (property === null || property === void 0 ? void 0 : property.amenities) || [];
    const updateAmenity = (amenity) => {
        update({ amenities: (0, exports.updateAmenityInList)(selected, props.propertyId, amenity) });
    };
    const updateMany = (updated) => {
        update({ amenities: updateManyAmenitiesInList(selected, props.propertyId, updated) });
    };
    const findSelected = (amenity) => {
        const target = available.find((a) => a.name === amenity);
        return selected.find((sel) => sel.amenity_type === (target === null || target === void 0 ? void 0 : target.name));
    };
    /*
    https://github.com/TravelNest/task-based-property/pull/158
    The purpose of the below is to move the newly added `Unknown` sub type
    to the bottom of the select lists. This is a temp measure we are applying
    in order to provide as nice a UX as possible before migrating the amenites.
    All it does is removes the unknown subtype if it exists and then re-adds it
    onto the end of the returned array.
    */
    const reorderSubselections = (subSelections) => {
        if (subSelections.length === 0)
            return subSelections;
        const unknown = subSelections.find((ss) => ss.value === 'unknown');
        const newSubSelections = subSelections.filter((ss) => ss.value !== 'unknown');
        return unknown ? [...newSubSelections, unknown] : subSelections;
    };
    const columns = categories_1.default.reduce((cols, cat, idx) => {
        cols[idx % 2 === 0 ? 0 : 1].push(cat);
        return cols;
    }, [[], []]);
    return React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.AMENITIES_FEATURES, property: property, viewState: loading ? viewstate_1.ViewState.LOADING : viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, null, !loading && columns.map((col, idx) => {
            return React.createElement(TaskPage_1.TaskColumn, { width: 50, key: `task-column-${idx}` }, col.map((section) => {
                const amenities = section.amenities.map((amenity) => {
                    const selectedAmenity = findSelected(amenity);
                    const possibleSubSelections = available
                        .filter((av) => av.name === amenity)
                        // XXX, TODO: We need to keep the default for 'television' until the Amenities overhaul is done
                        .filter((av) => av.subtype !== DEFAULT_SUBTYPE_VALUE || amenity === 'television')
                        .map((av) => ({ label: (0, capitalize_1.capitalize)(av.subtype), value: av.subtype }));
                    // Every amenity's subtype is "default" when it has none, so >= 2 means there really are subtypes
                    const hasSubSelections = possibleSubSelections.length >= 2;
                    const subSelections = hasSubSelections ? reorderSubselections(possibleSubSelections) : undefined;
                    let subSelectionValue;
                    if (selectedAmenity) {
                        subSelectionValue = selectedAmenity.amenity_subtype;
                    }
                    else {
                        // Default to the first sub-selection if the amenity isn't currently already selected,
                        // which prevents us defaulting to "Unknown" on new amenity selections
                        subSelectionValue = hasSubSelections ? subSelections[0].value : DEFAULT_SUBTYPE_VALUE;
                    }
                    return {
                        name: amenity,
                        selected: !!selectedAmenity,
                        subSelections,
                        subSelectionValue
                    };
                });
                return React.createElement(AmenitySection_1.AmenitySection, { id: section.id, key: section.id, title: section.heading, amenities: amenities, onCheckboxClick: (amenity) => updateAmenity(amenity), onOptionClick: (amenity) => updateAmenity(amenity), onSelectAllClick: updateMany });
            }));
        })));
};
//# sourceMappingURL=AmenitiesPage.js.map